<template>
  <div class="product-list">

    <div class="results-count">
      <p>{{ t('found_items_count') }}&nbsp;<span>{{found}}</span></p>
    </div>

    <div class='bikes matched'>
      <h3 class="serie-logo"></h3>
      <ul class='products'>
        <li v-bind:key="product_index" v-for="(product,product_index) in bikes"
            v-bind:class="{
                'matched': true,
                'bike' : true,
                'kind-f': product.gender === 'F',
                'kind-m': product.gender === 'M',
                'kind-k': product.gender === 'K',
                }">
          <item :product="product"/>

        </li>
      </ul><!-- product -->
    </div><!-- list wrap -->

    <div class='accessories matched'>
      <h3 class="serie-logo"></h3>
      <ul class='products'>
        <li v-bind:key="product_index" v-for="(product,product_index) in accessories"
            v-bind:class="{
                'matched': true,
                'accessory' : true,
                'kind-f': product.gender === 'F',
                'kind-m': product.gender === 'M',
                'kind-k': product.gender === 'K',
                'kind-u': product.gender === 'U',
                }">
          <item :product="product"/>

        </li>
      </ul><!-- product -->
    </div><!-- list wrap -->

    <div id='not-found' v-if="found === 0">
      <h1>{{ t('nothing_found') }}</h1>
    </div>

  </div>
</template>

<script>
  import Item from './../Products/Item.vue'

  import _ from 'lodash'

  export default {
    name: 'results',
    props: {
      searchString: String
    },
    components: { Item },
    data () {
      return {
        found: 0,
        results: [],
      }
    },
    computed: {
      bikes () {
        return  _.filter(this.results, {type: 'b'});
      },
      accessories () {
        return  _.filter(this.results, {type: 'a'});
      }
    },
    mounted () {
      this.search();
    },
    methods: {
      /**
       * Tłumaczenie stringów z tablicy przekazanej z serwera
       */
      t: function (txt) {
        if (_.has(translations, txt)) {
          return translations[txt]
        }
        return txt
      }, // t
      search() {

        // talica na znalezione elementy
        let found = [];
        this.results = [];

        // nie ma czego szukać to nie ma wyników
        if (this.searchString.length === 0) return;
        console.log("Searching for: ", this.searchString);

        // szukamy słów zaczynająch się od podanych liter bez względu na wielkość liter
        let regex = new RegExp('\\b' + this.searchString, 'gi')

        // torzymy listę pasujących rowerów
        _.forEach(env.data.bikes, bike => {
          if (bike.name.match(regex) !== null) {
            found.push(bike)
          }
        })
        // dołączamy pasujące akcesoria
        _.forEach(env.data.accessories, acc => {
          if (acc.name.match(regex) !== null) {
            found.push(acc)
          }
        })

        this.found = found.length;

        this.results = found;
        //console.log('results', this.results);

      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Search/Results.vue